import * as THREE from "three";
import { mergeGeometries } from "three/examples/jsm/utils/BufferGeometryUtils.js";
import { GROUND_SIZE, MAP_BOXES } from "@mmo/shared";

function colorize(g: THREE.BufferGeometry, hex: number): THREE.BufferGeometry {
  const r = ((hex >> 16) & 255) / 255;
  const gn = ((hex >>  8) & 255) / 255;
  const bl =  (hex        & 255) / 255;
  const n = g.attributes.position.count;
  const arr = new Float32Array(n * 3);
  for (let i = 0; i < n; i++) { arr[i*3] = r; arr[i*3+1] = gn; arr[i*3+2] = bl; }
  g.setAttribute("color", new THREE.BufferAttribute(arr, 3));
  return g;
}

export function buildMap(scene: THREE.Scene): void {
  const ground = new THREE.Mesh(
    new THREE.PlaneGeometry(GROUND_SIZE, GROUND_SIZE),
    new THREE.MeshLambertMaterial({ color: 0x4a7a3a }),
  );
  ground.rotation.x = -Math.PI / 2;
  scene.add(ground);

  // All static boxes baked into one BufferGeometry — single draw call for the map.
  const parts: THREE.BufferGeometry[] = [];
  for (const b of MAP_BOXES) {
    const g = new THREE.BoxGeometry(b.sx, b.sy, b.sz);
    g.translate(b.cx, b.cy, b.cz);
    parts.push(colorize(g, b.color));
  }
  const merged = mergeGeometries(parts, false);
  for (const p of parts) p.dispose();
  if (merged) {
    const mesh = new THREE.Mesh(
      merged,
      new THREE.MeshLambertMaterial({ vertexColors: true }),
    );
    scene.add(mesh);
  }
}
